import { Tooltip } from 'antd'
import Pagination from 'components/Pagination'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import { EmptyAnchor } from '../../../../components/CommonStyles'
import { StyledTableSqare } from '../../../../components/TableStyles/TableStylesSqare/TableStylesSqare'
import CloseRoleDrawer from '../../../../components/UIComponents/CloseRolePopup'
import SucessfullPopup from '../../../../components/UIComponents/CloseRolePopup/SucessfullModelPopup'
import TableSearchFilter from '../../../../components/UIComponents/TableSearchFilter'
import EmptyStateImage from '../../../../components/icons/EmptyState'
import DeleteRuleIcon from '../../../../components/icons/RuleEngineTableIcons/DeleteRuleIcon'
import SuccessIcon from '../../../../components/icons/SubmitCloseIcon'
import Debounce from '../../../../utils/Debounce'

import { EmptyStateContainer } from '../../../Events/ListView/List/style'
import {
  seRuleListWay,
  setIsRuleEdited,
  setSelectedDegreesAndDepartmentsList,
} from '../../action'
import {
  ContentCenterDiv,
  countStyle,
  DateText,
  DegreeDepartmentWrapper,
  DeleteLink,
  RERightArrowIcon,
  ruleItemStyle,
  RulesActiveWrapper,
  SetColDiv,
  SetContainer,
  SetLink,
} from '../Dashboard/style'
import { formatWithHyphens } from '../RuleEngineCommonFunction'

const RulesSetTable = ({
  data,
  getRuleSetData,
  status,
  mode = 'rule',
  deleteRule,
  emptyState,
  setUpNewRules,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const resultData = data?.result || []
  const [showRoleDrawer, setShowRoleDrawer] = useState(false)
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchValue, setSearchValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [orderBy, setOrderBy] = useState('')
  const [sort, setSort] = useState('')
  const [selectedRowObject, setSelectedRowObject] = useState({})

  const handleDelete = async () => {
    if (selectedRowObject) {
      try {
        const response = await deleteRule({ ruleId: selectedRowObject.id })

        if (response?.status >= 200 && response?.status <= 300) {
          setShowRoleDrawer(false)
          setShowSuccessPopup(true)
          getRuleSetData({
            setLoading,
            status,
            pageNo: currentPage,
            sort,
            orderBy,
          })
          if (setUpNewRules) setUpNewRules()
        }
      } catch (error) {
        ErrorMessage(
          error?.response?.data?.message ||
            'Failed to delete the rule. Please try again.'
        )
        setShowRoleDrawer(false)
      }
    }
  }

  const onSortingChange = (filter, sorter) => {
    setSort(sorter)
    getRuleSetData({ setLoading, status, pageNo: currentPage, sort, orderBy })
  }

  const sortFilter = sort => {
    let sortOrder = orderBy
    if (sort === sort) {
      if (sortOrder === 'asc') {
        sortOrder = 'desc'
      } else if (sortOrder === 'desc') {
        sortOrder = ''
        sort = ''
      } else {
        sortOrder = 'asc'
      }
    } else {
      sortOrder = 'asc'
    }

    setOrderBy(sortOrder)
    setSort(sort)
  }

  const closePopup = () => {
    setShowSuccessPopup(false)
  }

  const showConfirm = ruleObj => {
    setSelectedRowObject(ruleObj)

    setShowRoleDrawer(true)
  }

  useEffect(() => {
    getRuleSetData({ setLoading, status, pageNo: currentPage, sort, orderBy })
  }, [currentPage, sort, orderBy])

  const handlePageChange = (page, size) => {
    setCurrentPage(page)
    setPageSize(size)
  }

  const handleEditClick = data => {
    const isDraftPage = location.pathname.includes('/draft-page')
    dispatch(seRuleListWay(isDraftPage || false))
    navigate(`/ruleEngine/rule-creation/${data?.id}`)
  }

  // Function to check active rules based on category
  const renderRuleItem = (label, item, total, type) => {
    let activeCount = 0

    if (label === 'Placement') {
      if (item?.ctcRule?.isEnabled) activeCount++
      if (item?.brands?.isEnabled) activeCount++
      if (item?.roleApplyPermit?.isEnabled) activeCount++
      if (item?.maxRolesAllowed?.isEnabled) activeCount++
      if (item?.absentCount?.isEnabled) activeCount++
      if (item?.applicationStatusThreshold?.isEnabled) activeCount++
    } else {
      const rules = item?.jobCategory?.[type]
      if (rules?.isEnabled) activeCount++
    }

    return (
      <div style={ruleItemStyle}>
        <span>{label} - </span>
        <span>
          <span style={countStyle}>
            {activeCount} / {total}
          </span>{' '}
          {total > 1 ? 'rules are' : 'rule is'} set
        </span>
      </div>
    )
  }

  const columns = [
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {mode === 'draft' ? 'Draft Set' : 'Rule Set'}
        </div>
      ),
      dataIndex: 'ruleName',
      key: 'SET',
      align: 'left',
      width: 130,
      fixed: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('ruleName')
          },
        }
      },
      render: (text, data) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SetContainer>
            <div>
              <SetLink onClick={() => handleEditClick(data)}>
                <Tooltip title={text}>
                  <EmptyAnchor
                    style={{
                      color: 'rgba(50, 73, 215, 1)',
                      textWrap: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {text?.length > 25 ? `${text.substring(0, 25)}...` : text}
                  </EmptyAnchor>
                </Tooltip>
                <RERightArrowIcon />
              </SetLink>

              <DateText>
                {data.effectiveDate
                  ? formatWithHyphens(data?.effectiveDate)
                  : formatWithHyphens(data?.updateAt)}
              </DateText>
            </div>
            <SetColDiv>
              <DeleteLink onClick={() => showConfirm(data)}>Delete</DeleteLink>
            </SetColDiv>
          </SetContainer>
        </div>
      ),
    },
    {
      title: 'Degree & Department',
      dataIndex: 'degreeStreamMapId',
      key: 'Degree & Department',
      align: 'left',
      width: 200,

      render: degreeStreamMapId => (
        <DegreeDepartmentWrapper>
          {degreeStreamMapId?.map((item, index) => (
            <div key={index + item?.stream?.name} style={{ paddingBottom: 5 }}>
              {item?.degree?.shortForm} - {item?.stream?.name}
            </div>
          ))}
        </DegreeDepartmentWrapper>
      ),
    },
    {
      title: 'Rules Active',
      key: 'Rules Active',
      align: 'left',
      width: 140,
      render: item => (
        <RulesActiveWrapper>
          {renderRuleItem('Placement', item, 6, '')}
          {renderRuleItem('Internship', item, 1, 'internship')}
          {renderRuleItem('Apprenticeship', item, 1, 'apprenticeship')}
          {renderRuleItem('Gig', item, 1, 'gigs')}
        </RulesActiveWrapper>
      ),
    },
  ]

  const handleSearch = e => {
    setSearchValue(e.target.value)
    delayToFetchList(e.target.value)
  }

  useEffect(() => {
    setSelectedDegreesAndDepartmentsList({
      check: false,
      list: [],
    })
    dispatch(setIsRuleEdited(false))
  }, [])

  const delayToFetchList = useCallback(
    Debounce(value => {
      getRuleSetData({
        setLoading,
        status,
        pageNo: currentPage,
        sort,
        orderBy,
        search: value,
      })
    }, 500),
    []
  )

  return (
    <>
      {!loading && !emptyState ? (
        <EmptyStateContainer>
          <EmptyStateImage />
          No rules set!
        </EmptyStateContainer>
      ) : (
        <>
          <TableSearchFilter
            width={'95%'}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            handleSearch={handleSearch}
            hideFilter={true}
            customTableHeight={'55px'}
            ruleEngine={true}
            padding={'0px 20px'}
            totalCount={data?.count || 0}
            currentCount={
              data?.count < 10
                ? data?.count
                : data?.page * 10 - 10 + resultData?.length
            }
          />
          <StyledTableSqare
            columns={columns}
            dataSource={loading ? [] : resultData}
            pagination={false}
            onChange={onSortingChange}
            loading={loading}
            width={'95%'}
          />

          <ContentCenterDiv>
            <Pagination
              totalPages={data?.count}
              pageSize={pageSize}
              onChange={handlePageChange}
              current={currentPage}
            />
          </ContentCenterDiv>
        </>
      )}

      <CloseRoleDrawer
        description={
          <div>
            Are you sure you want to{' '}
            <b>delete this "{selectedRowObject?.ruleName || 'Rule Set'}"</b>
          </div>
        }
        Icon={DeleteRuleIcon}
        showDrawer={showRoleDrawer}
        setShowDrawer={setShowRoleDrawer}
        onApprove={handleDelete}
        onCloseClick={()=>setShowRoleDrawer(false)}
      />
      <SucessfullPopup
        description={
          <div>
            <b>"{selectedRowObject?.ruleName || 'Rules Set'}" is deleted.</b>
          </div>
        }
        Icon={SuccessIcon}
        showDrawer={showSuccessPopup}
        setShowDrawer={setShowSuccessPopup}
        onCloseClick={closePopup}
      />
    </>
  )
}

export default RulesSetTable
